
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import Select from "./Select.vue";
import Component, { mixins } from "vue-class-component";
import { getModule } from "vuex-module-decorators";
import SystemModule from "@/store/modules/system";
const systemModuleState = getModule(SystemModule);

@Component({
  components: {
    Select
  }
})
export default class ChargeTypeSelect extends mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  get types() {
    return systemModuleState.chargeTypes.map(x => ({ label: x.description, value: x.itemCode }));
  }
}
